import { useEffect, useRef } from 'react';
import { createPortal } from 'react-dom';
import Lottie from 'lottie-react';
import { useTranslation } from 'react-i18next';
import * as startAnimationData from '../../../assets/lottie/start-animation.json';
import { ParkingTypeEnum } from '../../../utils/utilTypes';

const DISMISS_AFTER_MS = 3000;

type Props = {
  parkingType: ParkingTypeEnum | null | undefined;
  onDismiss: () => void;
};

export const SessionStartedOverlay = ({ parkingType, onDismiss }: Props) => {
  const { t } = useTranslation();
  const onDismissRef = useRef(onDismiss);
  onDismissRef.current = onDismiss;

  useEffect(() => {
    const timer = setTimeout(() => onDismissRef.current(), DISMISS_AFTER_MS);
    return () => clearTimeout(timer);
  }, []);

  const ns = parkingType === 'rental' ? 'rental' : 'parking';

  return createPortal(
    <div
      className="fixed inset-0 z-[9999] flex flex-col items-center justify-center bg-primary"
      onClick={onDismiss}
    >
      <div className="w-64 h-64">
        <Lottie animationData={startAnimationData} loop={false} />
      </div>
      <p className="text-white text-2xl font-bold mt-4">
        {t(`sessionStartedOverlay.${ns}.title`)}
      </p>
      <p className="text-white text-sm mt-2 opacity-75">
        {t(`sessionStartedOverlay.${ns}.subtitle`)}
      </p>
    </div>,
    document.body,
  );
};
